import React from 'react';
import server from '../../server';

class ContactUs extends React.Component{
    constructor(props){
        super(props);
        this.state = {

        }
    }

    changeState = (e) =>{
        this.setState({[e.target.id]: e.target.value});
    }

    send = () =>{
        if(this.state.message == "") return this.props.alert("Mensagem Faltando!", "Por favor, preencha os dados corretamente", "warning");
        if(this.state.name == "") return this.props.alert("Nome Faltando!", "Por favor, preencha os dados corretamente", "warning");


        server.post("supports",this.state, (data) =>{
            if(data == "Posted"){
                this.reset();
                return this.props.alert("Mensagem Enviada", "Se for o caso retornaremos o contato!", "success");
            }
            else return this.props.alert("Erro!","Tente novamente mais tarde.","error");
        })
    }

    reset = () =>{
        this.setState({
            name: server.user.name, 
            email: server.user.email, 
            telephone: server.user.telephone,
            topic: "Dúvida",
            message:""    
        })
    }

    componentDidMount(){
        this.reset();
    }

    render(){
        return(
        <div class="col1-app">
            <div class="col1-app__wrapper">
                <div class="col2-list h-100p">
                    <div class="peers w-100p ai-c jc-sb content-header">
                        <div class="content-header__left">
                            <div class="content-header__title">
                                <h3 class="m-0">
                                    Fale com a Blues
                                </h3>
                            </div>

                        </div>
                    </div>
                    <div style={{width: "100%"}} class="scrollable h-100p">
                        <div class="content-data peers  ai-c jc-c">
                            <div class="contact-form  mT-30 mB-30">
                                <form action="" class="mB-30">
                                    <div class="mB-30">
                                        <div class="form-group col-md-12 m-0 p-0">

                                                <div style={{display:"contents"}} class="form-group col-md-4  m-0 p-0">
                                                        <div class="form-group col-md-12">
                                                                <label for="inputType">Assunto</label>
                                                                <select onChange={this.changeState} id="topic" value={this.state.topic} class="form-control" name="inputType">
                                                                    <option value="Dúvida">Dúvida</option>
                                                                    <option value="Elogio">Elogio</option>
                                                                    <option value="Reclamação">Reclamação</option>
                                                                    <option value="Indicar um Amigo">Indicar um amigo</option>
                                                                </select>
                                                            </div>
                                                        
                                                            <div class="form-group col-md-12">
                                                                <label for="inputName">Nome</label>
                                                                <input onChange={this.changeState} id="name" value={this.state.name} class="form-control" name="inputName" placeholder="Seu Nome" required="" type="text"/>
                                                            </div>
                                                            <div class="form-group col-md-12">
                                                                <label for="inputContact">Telefone</label>
                                                                <input onChange={this.changeState} id="telephone" value={this.state.telephone} class="form-control" name="inputContact" placeholder="Telefone de contato" required="" type="text"/>
                                                            </div>
                                                            <div class="form-group col-md-12">
                                                                <label for="inputContact">Email</label>
                                                                <input disabled={true} value={this.state.email} id="email" class="form-control" name="inputContact" placeholder="Email de contato" required="" type="text"/>
                                                            </div>
                                                            <div class="form-group col-md-12">
                                                                    <label for="inputName">Mensagem</label>
                                                                    <textarea onChange={this.changeState} id="message" value={this.state.message} class="form-control" rows="5" name="toDoctor" placeholder="Sua mensagem aqui" />
                                                                </div>
                                                 </div>
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>


                                    <div class="col-md-12 peers jc-c">
                                        <button class="btn btn-muted mR-20 c-client-secondary" type="button">Cancelar</button>
                                        <button onClick={this.send} class="btn btn-default" type="button">Enviar</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }
}

export default ContactUs


// WEBPACK FOOTER //
// ./src/pages/contactus/ContactUs.js